import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

import MainLayout from "../layouts/main";
import DashboardLayout from "../layouts/dashboard/toOrder";
import LogoOnlyLayout from "../layouts/LogoOnlyLayout";

import LoadingScreen from "../components/LoadingScreen";
import { Shop } from "redux/slices/auth";
import { PATH_LEVEL } from "utils/dataCenter";

const Loadable = (Component: React.ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  return (
    <Suspense
      fallback={
        null
        // <LoadingScreen
        //   sx={{
        //     ...(!isDashboard && {
        //       top: 0,
        //       left: 0,
        //       width: 1,
        //       zIndex: 9999,
        //       position: "fixed",
        //     }),
        //   }}
        // />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

// ----------------가맹 시작
// 홈 (발주 관리)
const HomeOrderAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Home/HomeOrderAnalytics"))
);
const HomeCalculate = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Home/HomeCalculate"))
);
// const HomeQuantityCalculation = Loadable(
//   lazy(
//     () => import("../pages/dashboard/toOrder/Home/HomeOrderQuantityCalculation")
//   )
// );
const HomeCookingRate = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Home/HomeCookingRate"))
);
// 매출 관리
const SalesAnaly = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Sales/SalesAnaly"))
);
const SalesByMenu = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Sales/SalesByMenu"))
);
const SalesMapAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/toOrderSC/Home/MapAnalytics"))
);

// 재고 관리
const InventoryAnalysis = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Inventory/InventoryAnalysis"))
);

const NoticeBoard = Loadable(
  lazy(() => import("../pages/dashboard/toOrder/Notice/NoticePage"))
);
// ----------------가맹 끝

// Main
const LandingPage = Loadable(lazy(() => import("../pages/LandingPage")));
const ComingSoon = Loadable(lazy(() => import("../pages/ComingSoon")));
const Maintenance = Loadable(lazy(() => import("../pages/Maintenance")));
const Page500 = Loadable(lazy(() => import("../pages/Page500")));
const NotFound = Loadable(lazy(() => import("../pages/Page404")));

export const DEFAULT_PATH = [
  {
    path: "*",
    element: <LogoOnlyLayout />,
    children: [
      { path: "coming-soon", element: <ComingSoon /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "500", element: <Page500 /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard/sales/salesanaly" replace />,
      },
    ],
  },
  { path: "*", element: <Navigate to="/404" replace /> },
];

export const getShopRoutes = (shop: Shop) => {
  const shopPath: any = {
    path: "/",
    element: <DashboardLayout />,
    children: [],
  };
  const { SHOP_AUTH, PLUG_IN_NB, PLUG_IN_MA } = shop;
  if (PLUG_IN_NB) {
    shopPath.children.push({
      path: "/",
      element: <Navigate to="/board/notice" replace />,
    });
    shopPath.children.push({
      path: "board",
      children: [{ path: "notice", element: <NoticeBoard /> }],
    });
  } else {
    shopPath.children.push({
      path: "/",
      element: <Navigate to="/sales/salesanaly" replace />,
    });
  }

  switch (SHOP_AUTH?.toString()) {
    case PATH_LEVEL.BASIC:
      if (PLUG_IN_MA) {
        shopPath.children = [
          ...shopPath.children,
          {
            path: "home",
            children: [
              { path: "orderanalytics", element: <HomeOrderAnalytics /> },
              { path: "cookingrate", element: <HomeCookingRate /> },
            ],
          },
          {
            path: "sales",
            children: [
              { path: "salesanaly", element: <SalesAnaly /> },
              { path: "salesbymenu", element: <SalesByMenu /> },
              { path: "mapanalytics", element: <SalesMapAnalytics /> },
            ],
          },
        ];
        break;
      } else {
        shopPath.children = [
          ...shopPath.children,
          {
            path: "home",
            children: [
              { path: "orderanalytics", element: <HomeOrderAnalytics /> },
              { path: "cookingrate", element: <HomeCookingRate /> },
            ],
          },
          {
            path: "sales",
            children: [
              { path: "salesanaly", element: <SalesAnaly /> },
              { path: "salesbymenu", element: <SalesByMenu /> },
            ],
          },
        ];
        break;
      }
    case PATH_LEVEL.STANDARD:
    case PATH_LEVEL.PREMIUM:
      if (PLUG_IN_MA) {
        shopPath.children = [
          ...shopPath.children,
          {
            path: "home",
            children: [
              // { path: "calculate", element: <HomeCalculate /> },
              { path: "orderanalytics", element: <HomeOrderAnalytics /> },
              // { path: "quantity", element: <HomeQuantityCalculation /> },
              { path: "cookingrate", element: <HomeCookingRate /> },
            ],
          },
          {
            path: "sales",
            children: [
              { path: "salesanaly", element: <SalesAnaly /> },
              { path: "salesbymenu", element: <SalesByMenu /> },
              { path: "mapanalytics", element: <SalesMapAnalytics /> },
            ],
          },
          { path: "inventory", element: <InventoryAnalysis /> },
        ];
        break;
      } else {
        shopPath.children = [
          ...shopPath.children,
          {
            path: "home",
            children: [
              // { path: "calculate", element: <HomeCalculate /> },
              { path: "orderanalytics", element: <HomeOrderAnalytics /> },
              // { path: "quantity", element: <HomeQuantityCalculation /> },
              { path: "cookingrate", element: <HomeCookingRate /> },
            ],
          },
          {
            path: "sales",
            children: [
              { path: "salesanaly", element: <SalesAnaly /> },
              { path: "salesbymenu", element: <SalesByMenu /> },
            ],
          },
          { path: "inventory", element: <InventoryAnalysis /> },
        ];
        break;
      }
    default:
      if (PLUG_IN_MA) {
        shopPath.children = [
          ...shopPath.children,
          {
            path: "sales",
            children: [
              { path: "salesanaly", element: <SalesAnaly /> },
              { path: "salesbymenu", element: <SalesByMenu /> },
              { path: "mapanalytics", element: <SalesMapAnalytics /> },
            ],
          },
        ];
      } else {
        shopPath.children = [
          ...shopPath.children,
          {
            path: "sales",
            children: [
              { path: "salesanaly", element: <SalesAnaly /> },
              { path: "salesbymenu", element: <SalesByMenu /> },
            ],
          },
        ];
      }
      break;
  }
  return [shopPath, ...DEFAULT_PATH];
};
